<template>
  <div class="head">
	<!-- <div class="banner"> -->
    <img width="100%" src="../assets/6387a8d53834b0a430eeadf2c4b95d3.png" alt="">
  <!-- </div> -->
    <div>
      <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      class="el-menu-demo"
      @select="handleSelect"
      background-color="#409EFF"
      text-color="#fff"
      active-text-color="#ffd04b">
      <el-menu-item index="1" @click.native="$router.replace('/')">网站首页</el-menu-item>
      <el-submenu index="2">
        <template slot="title">关于本会</template>
        <el-menu-item @click.native="$router.replace({ path: '/points', query: { idx: 1 } })" index="2-1">本会简介</el-menu-item>
        <el-menu-item @click.native="$router.replace({ path: '/points', query: { idx: 2 } })" index="2-2">本会章程</el-menu-item>
        <el-menu-item @click.native="$router.replace({ path: '/points', query: { idx: 3 } })" index="2-3">组织架构</el-menu-item>
        <el-menu-item @click.native="$router.replace({ path: '/points', query: { idx: 4 } })" index="2-4">联系方式</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">新闻动态</template>
        <el-menu-item @click.native="$router.replace('/dynamic/inform')" index="3-1">通知公告</el-menu-item>
        <el-menu-item @click.native="$router.replace('/dynamic/own_dynamic')" index="3-2">本会动态</el-menu-item>
        <el-menu-item @click.native="$router.replace('/dynamic/trade_dynamic')" index="3-3">行业动态</el-menu-item>
        <el-menu-item @click.native="$router.replace('/dynamic/video_news')" index="3-4">视频新闻</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">本会服务</template>
        <el-submenu index="4-1">
          <template slot="title">作品著作权登记</template>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 1}})" index="4-1-1">作品登记指南</el-menu-item>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 2}})" index="4-1-2">作品收费标准</el-menu-item>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 3}})" index="4-1-3">作品登记须知</el-menu-item>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 4}})" index="4-1-4">作品登记流程</el-menu-item>
        </el-submenu>
        <el-submenu index="4-2">
          <template slot="title">软件著作权登记</template>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 5}})" index="4-2-1">软件登记指南</el-menu-item>
        </el-submenu> 
        <el-submenu index="4-3">
          <template slot="title">版权纠纷调解</template>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 6}})" index="4-3-1">调解流程</el-menu-item>
        </el-submenu> 
        <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 7}})" index="4-4">作品比对鉴定</el-menu-item>
        <el-submenu index="4-5">
          <template slot="title">著作权登记资助</template>
          <el-menu-item @click.native="$router.replace({path: '/copyright/detail', query: {id: 8}})" index="4-5-1">著作权登记资助指南</el-menu-item>
        </el-submenu> 
      </el-submenu>
      <el-submenu index="5">
        <template slot="title">会员中心</template>
        <el-menu-item @click.native="$router.replace('/member/league')" index="5-1">联合会会员登记</el-menu-item>
        <el-menu-item @click.native="$router.replace('/member/committee')" index="5-2">工作委员会委员登记</el-menu-item>
        <el-menu-item @click.native="$router.replace('/member/business')" index="5-3">会员企业名录</el-menu-item>
        <el-menu-item @click.native="$router.replace('/member/mien')" index="5-4">会员风采</el-menu-item>
      </el-submenu>
      <el-submenu index="6">
        <template slot="title">法律事务</template>
        <el-menu-item @click.native="$router.replace('/legal')" index="6-1">经典案例</el-menu-item>
        <el-menu-item @click.native="$router.replace('/legal/mediation')" index="6-3">版权调解</el-menu-item>
      </el-submenu>
      <el-submenu index="7" class="policy" :popper-append-to-body="false">
        <template slot="title">法律法规</template>
        <el-submenu index="7-1">
          <template slot="title">法律</template>
          <el-menu-item v-for="(item, index) in law" :key="index" @click.native="$router.replace({path: '/policies/detail', query: { id: item.id }})" :index="'7-1-'+index">{{ item.title }}</el-menu-item>
        </el-submenu>
        <el-submenu index="7-2">
          <template slot="title">行政法规</template>
          <el-menu-item v-for="(item, index) in regulations" :key="index" @click.native="$router.replace({path: '/policies/detail', query: { id: item.id }})" :index="'7-2-'+index">{{ item.title }}</el-menu-item>
        </el-submenu>
        <el-submenu index="7-3">
          <template slot="title">部门规章</template>
          <el-menu-item v-for="(item, index) in departmental" :key="index" @click.native="$router.replace({path: '/policies/detail', query: { id: item.id }})" :index="'7-3-'+index">{{ item.title }}</el-menu-item>
        </el-submenu>
        <el-submenu index="7-4">
          <template slot="title">司法解释</template>
          <el-menu-item v-for="(item, index) in interpretation" :key="index" @click.native="$router.replace({path: '/policies/detail', query: { id: item.id }})" :index="'7-4-'+index">{{ item.title }}</el-menu-item>
        </el-submenu>
        <el-submenu index="7-5">
          <template slot="title">国际条约</template>
          <el-menu-item v-for="(item, index) in treaty" :key="index" @click.native="$router.replace({path: '/policies/detail', query: { id: item.id }})" :index="'7-5-'+index">{{ item.title }}</el-menu-item>
        </el-submenu>
      </el-submenu>
    </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  data() {
    return{
      activeIndex: "1",
      law: [],
      departmental: [],
      treaty: [],
      interpretation:[],
      regulations: []

    }
  },
  created(){
    window.addEventListener('load',e=>{
      this.$router.replace('/')
    } )
  },
  methods: {
    handleSelect(key, keyPath) {

    },
    omit(data) {
      for(var i in data) {
        if(data[i].title.length > 11) {
          data[i].title = data[i].title.substring(0, 11)+'...'
        }
      }
      return data;
    }
  },
  mounted(){

    this.$axios({
      url: 'http://copyright.gzcc315.com/policiesClassify',
      methods: 'get',
      data: {
        pageNum: 1,
        type: '法律'
      }
    }).then(res => {
      this.law = res.data.pageData;
    })

    this.$axios({
      url: 'http://copyright.gzcc315.com/policiesClassify',
      methods: 'get',
      data: {
        pageNum: 1,
        type: '行政法规'
      }
    }).then(res => {
      var data = res.data.pageData;
      this.regulations = this.omit(data);
    })

    this.$axios({
      url: 'http://copyright.gzcc315.com/policiesClassify',
      methods: 'get',
      data: {
        pageNum: 1,
        type: '部门规章'
      }
    }).then(res => {
      var data = res.data.pageData;
      this.departmental = this.omit(data);
    })

    this.$axios({
					url: 'http://copyright.gzcc315.com/policiesClassify',
					methods: 'get',
					data: {
						pageNum: 1,
						type: '司法解释'
					}
    }).then(res => {
      var data = res.data.pageData
      this.interpretation = this.omit(data);
    })

    this.$axios({
					url: 'http://copyright.gzcc315.com/policiesClassify',
					methods: 'get',
					data: {
						pageNum: 1,
						type: '国际条约'
					}
    }).then(res => {
      var data = res.data.pageData
      this.treaty = this.omit(data);
    })

  }
}
</script>

<style>
.el-menu--horizontal .el-menu-item, .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
}
.el-menu-demo {
  width: 100%;
  background-color: #409EFF;
  display: flex;
  justify-content: space-around;
}
ul.el-menu li {
  font-size: 14px;
}
.el-submenu__title {
  font-size: 14px !important;
}
.policy .el-menu--horizontal .el-menu--horizontal {
  /* position: absolute;
  top: 205px; */
  /* left: -250px !important; */
}
</style>
<style scoped>
.head .banner {
	width: 100%;
	height: 190px;
	background: url('../assets/1595236164.png') no-repeat;
	background-size: cover;
  position: relative;
}
.head .banner img {
  position: absolute;
  top: 20px;
  left: 500px;
}
.head > div:last-child {
	background: #409EFF;
	padding: 0 15%;
}
</style>
